module.exports = __webpack_public_path__ + "assets/img/WhatsApp_b.7d4447d4.svg";